import React, { use, useState } from 'react';
import Button from './Buttons/Button';
import ScrollWrapper from './ScrollWrapper';
/*  Helper for Modals*/
export const useModal = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalContent, setModalContent] = useState(null);

    const openModal = (content) => {
        setModalContent(content);
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setModalContent(null);
        setIsModalOpen(false);
    };

    const ModalView = ({classNames = "w-full h-full", modalColor= "bg-white"}) =>
        isModalOpen ? (
            <div className="h-full fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 p-10">
                <div className= {`${modalColor} p-5 rounded-md shadow-md relative ${classNames}`}>
                    {/* Close Button */}
                    <Button onClickAction={closeModal} iconName={"cross.svg"} classNames='w-9 h-9 absolute top-2 right-2 p-2 border-0' buttonColor={modalColor === "bg-white" ? 'transparent' : 'bg-white'}/>
                    {/* Modal Content */}
                    <ScrollWrapper>{modalContent}</ScrollWrapper>
                </div>
            </div>
        ) : null;

    return { ModalView, openModal, closeModal };
};